import CustomBlockButton from "../../../../../../../components/button/CustomBlockButton";
import { CustomDialog } from "../../../../../../../components/dialog/v1/CustomDialog";
import styled from 'styled-components';

const StyledHeader = styled.div`
    padding: 10px;
`;
const StyledBody = styled.div`
    padding: 10px;
    display: flex;
    flex-direction: column;
    gap: 10px;
    button{
        border-radius: 3px;
    }
`;

export function ModalValueTypeChange({
    open,
    onClose,
    onSelect,
}) {
    return (
        <>
            <CustomDialog
                open={open}
                onClose={onClose}
            >
                <StyledHeader>
                    <CustomDialog.Header>
                        <CustomDialog.Header.Fake />
                        <CustomDialog.Header.Title>
                            값 유형 변경
                        </CustomDialog.Header.Title>
                        <CustomDialog.Header.Close onClick={onClose} />
                    </CustomDialog.Header>
                </StyledHeader>
                <StyledBody>
                    <CustomBlockButton
                        type='button'
                        onClick={()=>onSelect('NORMAL')}
                    >일반</CustomBlockButton>
                    <CustomBlockButton
                        type='button'
                        onClick={()=>onSelect('FIXED')}
                    >고정값</CustomBlockButton>
                    <CustomBlockButton
                        type='button'
                        onClick={()=>onSelect('FREIGHT_CODE')}
                    >운송코드</CustomBlockButton>
                </StyledBody>
            </CustomDialog>
        </>
    );
}